import CommonTypes from '../@types/redux/store/CommonTypes';
import { DialogOption } from './showAlert';
import { injectedStore } from '../globals/StoreAccess';

export const showWebAlert = (
  title: string,
  message: string,
  yesActionText: any = null,
  yesAction: () => void = () => {},
  noActionText: any = null,
  noAction: () => void = () => {},
  isDestructive: boolean = false
) => {
  const dialog = {
    title,
    message,
    yesActionText,
    yesAction,
    noActionText,
    noAction,
    isDestructive,
  };
  injectedStore.dispatch({ type: CommonTypes.SET_DIALOG, payload: { dialog } });
};

export const showWebAlertWithOptions = (
  title: string,
  message: string,
  options: DialogOption[] = [],
  isDestructive: boolean = false
) => {
  const dialog = {
    title,
    message,
    options,
    isDestructive,
  };
  injectedStore.dispatch({ type: CommonTypes.SET_DIALOG, payload: { dialog } });
};
